import { Field } from 'react-final-form';
import Tooltip from 'react-tooltip-lite';
import CustomRadioButton from '../../../../components/form/CustomRadioButton';
import Icon from '../../../../assets/icons/Icon';
import { useDict } from '../../../../contexts/LanguageContext';
import { InvestorCategory } from '../../../../utils/constants';

const HighNetWorthInvestor = ({ submitted }) => {
    const dict = useDict();

    return (
        <span style={{ width: '100%' }}>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.investorClassification}
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                    <Tooltip
                        data-html="true"
                        content={
                            <div>
                                <ul>
                                    <li>{dict.highNetWorthInvestor}:
                                        <ul>
                                            <li>{dict.highNetWorthInvestorList1}</li>
                                            <li>{dict.highNetWorthInvestorList2}</li>
                                            <li>{dict.highNetWorthInvestorList3}</li>
                                        </ul>
                                    </li>
                                    <li>{dict.highNetWorthEntity}</li>
                                    <ul>
                                        <li>{dict.highNetWorthEntityList1}</li>
                                        <li>{dict.highNetWorthEntityList2}</li>
                                        <li>{dict.highNetWorthEntityList3}</li>
                                    </ul>
                                </ul>
                            </div>
                        }
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon icon="InfoCircle" />
                    </Tooltip>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="investor_category_id" type="radio" value={InvestorCategory.Retail}>
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.retail}
                                    className="colored"
                                    submit={submitted}
                                    data-cy="investor_category_id__radio_retail"
                                />
                            )}
                        </Field>
                        <Field name="investor_category_id" type="radio" value={InvestorCategory.HNWI}>
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.highNetWorthInvestorShort}
                                    className="colored"
                                    submit={submitted}
                                    data-cy="investor_category_id__radio_hnwi"
                                />
                            )}
                        </Field>
                        <Field name="investor_category_id" type="radio" value={InvestorCategory.HNWE}>
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.highNetWorthEntityShort}
                                    className="colored"
                                    submit={submitted}
                                    data-cy="investor_category_id__radio_hnwe"
                                />
                            )}
                        </Field>
                        <Field name="investor_category_id" type="radio" value={InvestorCategory.Institutional}>
                            {({ input, meta }) => (
                                <CustomRadioButton
                                    input={input}
                                    meta={meta}
                                    label={dict.institutionalInvestor}
                                    className="colored"
                                    submit={submitted}
                                    data-cy="investor_category_id__radio_hnwe"
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        </span>
    );
};

HighNetWorthInvestor.defaultProps = {
    submitted: false,
};

export default HighNetWorthInvestor;
